/** 장비모니터링 개요 custom hooks */
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { request } from "../../common/api";
import {
  GET_EQUIPMENT_ALARM_STATUS,
  GET_EQUIPMENT_OPERATION_STATUS_LED,
  GET_EQUIPMENT_OPERATION_STATUS_TIME,
  GET_EQUIPMENT_SENSOR_ALARM_STATUS,
} from "../query-keys";

import { EquipmentAlarmStatus } from "../types/equipment-monitoring";
import { EquipmentDefaultValuesTypes } from "../../types/equipment";
import { EquipmentOperationStatusLED } from "../types/equipment";

/** 장비 모니터링 장비 정보 관련 커스텀 훅 */
const useEquipmentMonitSummary = (
  searchDefaultValues: EquipmentDefaultValuesTypes
) => {
  const [search, setSearch] =
    useState<EquipmentDefaultValuesTypes>(searchDefaultValues);

  /** 장비모니터링> 가스터빈 > 장비운용현황 최근 장비 작동 시간 조회
   * ? fetch 코드 수정 완료 2025.05.23
   * ! 백엔드 메인 쿼리 수정 필요
   */
  const { data: equipmentOperationStatusTime } = useQuery({
    queryKey: [
      GET_EQUIPMENT_OPERATION_STATUS_TIME,
      search.mcyCode,
      search.shipNo,
    ],
    queryFn: async () => {
      return await request<any>({
        method: "GET",
        url: `/equipment-monitoring/operation-status?mcyCode=${search.mcyCode}&shipNo=${search.shipNo}`,
      }).then((res: any) => {
        return res.data;
      });
    },
  });

  /** 장비모니터링> 가스터빈 > 개요> 계통별 알람현황 조회
   * * fetch 코드 수정 완료 2025.05.23
   */
  const { data: alarmStatusData } = useQuery({
    queryKey: [GET_EQUIPMENT_ALARM_STATUS, search],
    queryFn: async () => {
      return await request<EquipmentAlarmStatus>({
        method: "GET",
        url: `/equipment-monitoring/alarm-status`,
        params: {
          steShiptypeNo: search.shipTypeNo,
          steShipNo: search.shipNo,
          steMcyName: search.mcyName,
          steAlarmTime: search.alarmStatusTime,
        },
      }).then((res: any) => {
        return res.data;
      });
    },
    enabled: !!search.shipNo && !!search.shipTypeNo, // shipId와 shiptypeId가 있을 때만 실행
  });

  /** 장비모니터링> 가스터빈 > 개요> 센서 알림현황 조회
   * * fetch 코드 수정 완료 2025.05.23
   */
  const { data: sensorAlarmData } = useQuery({
    queryKey: [GET_EQUIPMENT_SENSOR_ALARM_STATUS, search],
    queryFn: async () => {
      return await request<EquipmentAlarmStatus>({
        method: "GET",
        url: `/equipment-monitoring/sensor-alarm`,
        params: {
          steShiptypeNo: search.shipTypeNo,
          steShipNo: search.shipNo,
          steMcyName: search.mcyName,
        },
      }).then((res: any) => {
        return res.data;
      });
    },
    enabled: !!search.shipNo && !!search.shipTypeNo, // shipId와 shiptypeId가 있을 때만 실행
  });

  /** 전체 장비 운용의 장비 버튼 색( 해당 장비에 속한 센서의 worst case) */
  const { data: equipmentOperationStatusLED } = useQuery({
    queryKey: [GET_EQUIPMENT_OPERATION_STATUS_LED],
    queryFn: async () => {
      return await request<EquipmentOperationStatusLED>({
        method: "GET",
        url: `/equipment/operation/status/led`,
        params: {
          steShiptypeNo: search.shipTypeNo,
          steShipNo: search.shipNo,
        },
      });
    },
  });

  // 계통 장비 변경 핸들러
  const handleLowMcyNameChange = (lowMcyName: string) => {
    setSearch({
      ...search,
      lowMcyName: lowMcyName,
    });
  };

  useEffect(() => {
    setSearch(searchDefaultValues);
  }, [searchDefaultValues]);
  return {
    search,
    /** 장비운용현황 시간 */
    equipmentOperationStatusTime,
    /** 장비알람현황 */
    alarmStatusData,
    /** 센서알림현황 */
    sensorAlarmData,
    /** 전체 장비 운용의 장비 버튼 색( 해당 장비에 속한 센서의 worst case) */
    equipmentOperationStatusLED,
    /** 계통 장비 변경  */
    handleLowMcyNameChange,
  };
};

export default useEquipmentMonitSummary;
